<div class="mat-dialog-container">
	<h2 mat-dialog-title>{{ "ORDER_BASKET.HISTORY_DIALOG.TITLE" | translate }}</h2>
	<div mat-dialog-content>
		<div class="table-container">
			<table #orderHistoryTable
				   mat-table
				   matSort
				   matSortActive="timestamp"
				   matSortDirection="asc"
				   [dataSource]="orderHistoryTableDataSource">
				<ng-container *ngFor="let column of orderHistoryTableColumnDefs" [matColumnDef]="column.key">
					<th mat-header-cell *matHeaderCellDef mat-sort-header
						class="{{ column.className }}">
						{{ column.heading | translate }}
					</th>
					<td mat-cell
						*matCellDef="let row"
						[title]="column.displayValue ? column.displayValue(row) : row[column.key] || ''"
						class="{{ column.className }}">
						{{ column.displayValue ? column.displayValue(row) : row[column.key] }}
					</td>
				</ng-container>
				<tr mat-header-row *matHeaderRowDef="orderHistoryTableDisplayedColumns"></tr>
				<tr mat-row *matRowDef="let row; columns: orderHistoryTableDisplayedColumns"></tr>
				<tr class="mat-row" *matNoDataRow>
					<td class="mat-cell no-history-record-text" [attr.colspan]="orderHistoryTableDisplayedColumns.length">
						{{'ORDER_BASKET.HISTORY_DIALOG.NO_HISTORY_RECORD' | translate}}
					</td>
				</tr>
			</table>
		</div>
	</div>
	<div mat-dialog-actions class="button-container">
		<button mat-flat-button
				(click)="closeDialog()">{{'ACTION_BUTTON_LABELS.CLOSE' | translate}}</button>
	</div>
</div>
